var _ellipse, _ellipse2, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearnActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5391,
    cy: 24.9682,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_9485_128044)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5389,
    cy: 24.9678,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_9485_128044)",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 12.5,
    r: 11,
    fill: "#4FF1DE",
    stroke: "#4FF1DE",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.34 7.08279C13.887 6.44353 12.3083 6.58082 11.009 7.45847C9.75126 8.30809 9 9.70723 9 11.2007C9 12.7382 9.6107 13.5463 10.2013 14.3278C10.712 15.0033 11.1939 15.6415 11.3611 16.7912C11.4349 17.301 11.8756 17.6855 12.3855 17.6855H14.6002C15.1178 17.6855 15.5654 17.2978 15.6416 16.7834C15.8095 15.6383 16.2907 15.0019 16.8003 14.3278C17.3407 13.6127 17.8992 12.8734 17.9888 11.5718C18.1218 9.64124 17.0572 7.83734 15.34 7.08279Z",
    fill: "#FCD300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7143 12.1855H20.2857C20.1277 12.1855 20 12.0738 20 11.9355C20 11.7973 20.1277 11.6855 20.2857 11.6855H21.7143C21.8723 11.6855 22 11.7973 22 11.9355C22 12.0738 21.8723 12.1855 21.7143 12.1855Z",
    fill: "#069B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 20.6855H13.25C12.5608 20.6855 12 19.7883 12 18.6855V17.0855C12 16.8643 12.1118 16.6855 12.25 16.6855C12.3882 16.6855 12.5 16.8643 12.5 17.0855V18.6855C12.5 19.3471 12.8365 19.8855 13.25 19.8855H13.75C14.1635 19.8855 14.5 19.3471 14.5 18.6855V17.0855C14.5 16.8643 14.6118 16.6855 14.75 16.6855C14.8882 16.6855 15 16.8643 15 17.0855V18.6855C15 19.7883 14.4392 20.6855 13.75 20.6855Z",
    fill: "#505050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3401 7.68555C18.2409 7.68555 18.143 7.63618 18.0758 7.54135C17.9575 7.3746 17.9803 7.12973 18.126 6.99486L19.4465 5.77207C19.5923 5.63681 19.806 5.66324 19.9242 5.8296C20.0425 5.99634 20.0197 6.24121 19.874 6.37608L18.5535 7.59887C18.491 7.65717 18.4152 7.68555 18.3401 7.68555Z",
    fill: "#069B7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6598 16.6855C19.5847 16.6855 19.5093 16.6572 19.4464 16.5989L18.1261 15.376C17.98 15.2407 17.9576 14.9958 18.0759 14.8294C18.1941 14.6631 18.4081 14.637 18.5536 14.7719L19.8739 15.9948C20.02 16.1301 20.0424 16.375 19.9241 16.5413C19.8569 16.6362 19.759 16.6855 19.6598 16.6855Z",
    fill: "#069B7B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65981 7.68555C8.58473 7.68555 8.5093 7.65717 8.44645 7.59887L7.12614 6.37613C6.98004 6.24087 6.95762 5.99601 7.07585 5.82967C7.19409 5.66332 7.4078 5.63689 7.55356 5.77175L8.87386 6.9945C9.01996 7.12975 9.04238 7.37461 8.92415 7.54096C8.85688 7.63619 8.75902 7.68555 8.65981 7.68555Z",
    fill: "#069B7B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34011 16.6855C7.24089 16.6855 7.14303 16.6362 7.07575 16.5413C6.9575 16.3746 6.98027 16.1297 7.12604 15.9948L8.44649 14.7719C8.59227 14.637 8.806 14.6631 8.92425 14.8294C9.0425 14.9962 9.01973 15.2411 8.87396 15.376L7.55351 16.5989C7.49064 16.6572 7.41487 16.6855 7.34011 16.6855Z",
    fill: "#069B7B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71429 12.1855H5.28571C5.12771 12.1855 5 12.0738 5 11.9355C5 11.7973 5.12771 11.6855 5.28571 11.6855H6.71429C6.87229 11.6855 7 11.7973 7 11.9355C7 12.0738 6.87229 12.1855 6.71429 12.1855Z",
    fill: "#069B7B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9485_128044",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5391 24.9682) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9485_128044",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5389 24.9678) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnActive);
export default __webpack_public_path__ + "static/media/learn-active.e516065519138b883dc69eac78afe84a.svg";
export { ForwardRef as ReactComponent };